(function () {
  function init(hero) {
  if (!hero || hero.dataset.fbhReady) return;
  hero.dataset.fbhReady = '1';

  // Icon geometry from the design system's Icon component (24px grid, 2px round strokes) — same set as screenshot-2,
  // plus an arrow drawn to the same rules.
  var ICONS = {
    bundle: '<rect x="3.5" y="3.5" width="7" height="7" rx="2.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="2.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="2.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="2.5"/>',
    box: '<path d="M4 8.2 12 4l8 4.2v7.6L12 20l-8-4.2z"/><path d="M4.3 8.4 12 12.4l7.7-4"/><path d="M12 12.4V20"/><path d="M8 6.1l7.8 4.1"/>',
    shuffle: '<path d="M3.5 7.5H6c5.5 0 6.5 9 12 9h2"/><path d="M3.5 16.5H6c1.9 0 3.1-1.1 4.1-2.6"/><path d="M13.9 10.1c1-1.5 2.2-2.6 4.1-2.6h2"/><path d="M18 5.5l2 2-2 2M18 14.5l2 2-2 2"/>',
    percent: '<circle cx="7.5" cy="7.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/><path d="M18 6 6 18"/>',
    gift: '<rect x="4.5" y="11" width="15" height="9.5" rx="2.5"/><rect x="3" y="7" width="18" height="4" rx="2"/><path d="M12 7v13.5"/><path d="M12 7c-1-2.8-5-3.6-5-1.2C7 7 8.6 7 12 7z"/><path d="M12 7c1-2.8 5-3.6 5-1.2C17 7 15.4 7 12 7z"/>',
    bogo: '<rect x="3.5" y="3.5" width="7" height="7" rx="2.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="2.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="2.5"/><path d="M17 14v6M14 17h6"/>',
    tag: '<path d="M3.5 5.5v5.2a2 2 0 0 0 .6 1.4l7.8 7.8a2 2 0 0 0 2.8 0l5.2-5.2a2 2 0 0 0 0-2.8L12.1 4.1a2 2 0 0 0-1.4-.6H5.5a2 2 0 0 0-2 2z"/><circle cx="8.25" cy="8.25" r="1.5"/>',
    addon: '<rect x="3.5" y="8.5" width="11" height="11" rx="2.5"/><path d="M18 3.5v6M15 6.5h6"/>',
    crosssell: '<path d="M3 4h1.6a1.5 1.5 0 0 1 1.46 1.15L7.6 12.4a2 2 0 0 0 1.95 1.6h7.1a2 2 0 0 0 1.94-1.5l1.2-4.8a1 1 0 0 0-.97-1.2H6.3"/><circle cx="10" cy="19" r="1.5"/><circle cx="17" cy="19" r="1.5"/><path d="M12.9 8.2v3.6M11.1 10h3.6"/>',
    sparkle: '<path d="M11 4.5c.8 3.4 2.3 4.9 5.7 5.7-3.4.8-4.9 2.3-5.7 5.7-.8-3.4-2.3-4.9-5.7-5.7 3.4-.8 4.9-2.3 5.7-5.7z"/><circle cx="18" cy="18" r="1.6"/>',
    arrow: '<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>'
  };
  hero.querySelectorAll('[data-i]').forEach(function (el) {
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[el.dataset.i] + '</svg>';
  });

  var tabs = [].slice.call(hero.querySelectorAll('.fbh-tab'));
  var track = hero.querySelector('.fbh-track');
  var slides = [].slice.call(hero.querySelectorAll('.fbh-slide'));
  var resultEl = hero.querySelector('.fbh-result');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active = 0;
  if (!slides.length) return;

  function mark(i) {
    active = i;
    tabs.forEach(function (t, n) {
      var on = n === i;
      t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
      var bar = t.querySelector('.fbh-tab-timer'); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
    });
    slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n !== i); s.tabIndex = n === i ? 0 : -1; });
    var r = { label: slides[i].dataset.chipLabel, from: slides[i].dataset.chipFrom, to: slides[i].dataset.chipTo };
    resultEl.hidden = !r.label;
    resultEl.classList.remove('is-grown');
    resultEl.querySelector('.fbh-result-label').textContent = r.label;
    resultEl.querySelector('.fbh-result-from').textContent = r.from;
    resultEl.querySelector('.fbh-result-to').textContent = r.to;
    setTimeout(function () { if (active === i) resultEl.classList.add('is-grown'); }, reduce ? 0 : 450);
  }
  function go(i) {
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    mark(i);
    schedule();
  }

  // Swipe / trackpad scrolling keeps the tabs in sync.
  var scrollT;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollT);
    scrollT = setTimeout(function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== active) mark(i);
      schedule();
    }, 90);
  }, { passive: true });

  // ---------- Autoplay ----------
  var CYCLE = 5000;
  var autoplay = !reduce, paused = false, visible = true, timer = null;
  hero.style.setProperty('--cycle', CYCLE + 'ms');
  hero.classList.toggle('is-autoplay', autoplay);

  function schedule() {
    clearTimeout(timer);
    if (!autoplay || paused || !visible) return;
    timer = setTimeout(function () { go(active + 1); }, CYCLE);
  }
  function stopAutoplay() { autoplay = false; clearTimeout(timer); hero.classList.remove('is-autoplay'); }
  function setPaused(p) {
    paused = p; hero.classList.toggle('is-paused', p);
    if (p) { clearTimeout(timer); return; }
    var bar = hero.querySelector('.fbh-tab[aria-selected="true"] .fbh-tab-timer'); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
    schedule();
  }

  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { stopAutoplay(); go(i); });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      e.preventDefault(); stopAutoplay();
      var n = (i + d + tabs.length) % tabs.length; tabs[n].focus(); go(n);
    });
  });
  track.addEventListener('touchstart', stopAutoplay, { passive: true });
  track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stopAutoplay(); }, { passive: true });

  var demo = hero.querySelector('.fbh-demo');
  demo.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') setPaused(true); });
  demo.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') setPaused(false); });
  demo.addEventListener('focusin', function () { setPaused(true); });
  demo.addEventListener('focusout', function (e) { if (!demo.contains(e.relatedTarget)) setPaused(false); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) schedule(); else clearTimeout(timer); }, { threshold: 0.25 }).observe(demo);
  }
  document.addEventListener('visibilitychange', function () { visible = !document.hidden; if (visible) schedule(); else clearTimeout(timer); });
  window.addEventListener('resize', function () { track.scrollTo({ left: slides[active].offsetLeft, behavior: 'auto' }); });

  // ---------- Rating stars ----------
  var star = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>';
  var starsEl = hero.querySelector('.fbh-stars');
  if (starsEl) starsEl.innerHTML = star + star + star + star + star;

  // ---------- Ribbon: alternating Fast Bundle / Black Friday, duplicated for a seamless loop ----------
  var spark = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2c.9 5 2 6.1 7 7-5 .9-6.1 2-7 7-.9-5-2-6.1-7-7 5-.9 6.1-2 7-7z" transform="translate(0 3)"/></svg>';
  var run = '';
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
  for (var r = 0; r < 6; r++) run += '<span class="is-fb">' + esc(hero.dataset.ribbonA) + '</span><span>' + spark + '</span><span class="is-bf">' + esc(hero.dataset.ribbonB) + '</span><span>' + spark + '</span>';
  var ribbon = hero.querySelector('.fbh-ribbon-track');
  if (ribbon) ribbon.innerHTML = run + run;

  // ---------- First-visit hint ----------
  // Once per browser: the selector stretches right and the next slide peeks in. Add ?hint to the URL to replay it.
  var HINT_KEY = 'fbh-carousel-hint-seen', interacted = false;
  function seen() { try { return localStorage.getItem(HINT_KEY) === '1'; } catch (e) { return false; } }
  function remember() { try { localStorage.setItem(HINT_KEY, '1'); } catch (e) {} }
  ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (ev) {
    demo.addEventListener(ev, function () { interacted = true; hero.classList.remove('is-hint'); }, { passive: true });
  });
  function playHint() {
    if (interacted || active !== 0) return;
    hero.classList.add('is-hint');
    remember();
    setTimeout(function () { hero.classList.remove('is-hint'); }, 1800);
  }
  if (!reduce && (!seen() || /[?&]hint\b/.test(location.search))) {
    if ('IntersectionObserver' in window) {
      var hintIO = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        hintIO.disconnect();
        setTimeout(playHint, 1200);
      }, { threshold: 0.6 });
      hintIO.observe(demo);
    } else {
      setTimeout(playHint, 1200);
    }
  }

  hero.fbhGo = function (i) { stopAutoplay(); go(i); };

  mark(0);
  schedule();
  }

  function initAll() { document.querySelectorAll('.fbh').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.fbh')); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('.fbh-tab');
    var hero = tab && tab.closest('.fbh');
    if (hero && hero.fbhGo) hero.fbhGo([].indexOf.call(hero.querySelectorAll('.fbh-tab'), tab));
  });
})();
